import { useState } from "react";
import { Loader2, ArrowLeft } from "lucide-react";
import { adminApi, apiError } from "@/lib/api";
import { Field, RequiredLegend, focusFirstError, EMAIL_ERROR } from "@/components/landing/Field";

export const ForgotPasswordForm = ({ onBack }) => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    const err = EMAIL_ERROR(email);
    setError(err || "");
    if (err) return focusFirstError(e.currentTarget);
    setLoading(true);
    try {
      const { data } = await adminApi.post("/password/forgot", { email });
      setMessage(data.message);
    } catch (ex) {
      setError(apiError(ex));
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} noValidate data-testid="forgot-password-form" className="order-card w-full max-w-sm p-8 flex flex-col gap-4">
      <div>
        <span className="font-display text-2xl font-extrabold text-slate-900">Mot de passe oublié</span>
        <p className="text-sm text-slate-500 mt-1">Indiquez l'e-mail du compte admin ou l'e-mail de récupération.</p>
      </div>
      {message ? (
        <div data-testid="forgot-password-message" className="rounded-xl bg-emerald-50 border border-emerald-200 text-emerald-800 text-sm px-4 py-3">{message}</div>
      ) : (
        <>
          <RequiredLegend testId="forgot-password-legend" />
          <Field id="forgot-email" label="E-mail" required error={error}>
            <input id="forgot-email" type="email" data-testid="forgot-password-email-input" value={email} aria-invalid={!!error}
              onChange={(e) => { setEmail(e.target.value); setError(""); }} className="field-input" />
          </Field>
          <button type="submit" disabled={loading} data-testid="forgot-password-submit-button" className="btn-heat">
            {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Recevoir un lien"}
          </button>
        </>
      )}
      <button type="button" onClick={onBack} data-testid="forgot-password-back-button" className="text-sm text-sky-700 hover:underline self-center inline-flex items-center gap-1">
        <ArrowLeft className="w-4 h-4" /> Retour à la connexion
      </button>
    </form>
  );
};
